import { IMPERSONATED_USER_SUB, CACHE_KEYS } from "../../constants";

const { ORGANIZATION } = CACHE_KEYS

const addAWSToken = async (cognitoUser, config) => {
  const impersonatedUserSub = sessionStorage.getItem(IMPERSONATED_USER_SUB);
  const organization = JSON.parse(sessionStorage.getItem(ORGANIZATION));
  const now = Math.floor(new Date() / 1000);

  let accessToken = cognitoUser.signInUserSession.accessToken;
  let awsToken = accessToken.jwtToken;
  let refreshToken = cognitoUser.signInUserSession.refreshToken;

  if (accessToken.payload.exp - 600 < now)
    cognitoUser.refreshSession(refreshToken, (err, session) => {
      if (err) console.log("Unable to refresh token", err);
      else {
        accessToken = session.accessToken;
        awsToken = accessToken.jwtToken;
        refreshToken = session.refreshToken;
      }
    });

  if (!awsToken || !config) {
    return config;
  }
  const authorizationToken = `Bearer ${awsToken}`;
  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: authorizationToken,
      ...(impersonatedUserSub && { impersonatedUserSub }),
      ...(organization && { organizationId: organization.id }),
    },
  };
};

export default addAWSToken;
